import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of, tap } from 'rxjs';

import { PermissionsFacade } from '../infrastructure/permissions.facade';

export const permissionsGuard: CanActivateFn = (route, state) => {
    const permissionsFacade = inject(PermissionsFacade);
    const router = inject(Router);

    if (!route.data['permissions']) {
        console.warn(`You can't access ${state.url}. You must set "permissions" array to route data.`);

        return of(false);
    }

    return permissionsFacade.hasPermissions(route.data['permissions']).pipe(
        tap((value) => {
            if (!value) {
                router.navigateByUrl('/fallback');
            }
        })
    );
};
